export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-4-09.fc590ae1.jpg";